<template>
  <Search :categorySearch="category" />
</template>
<script>
import Search from './Search'

export default {
  name: 'CategorySearch',
  components: { Search },
  computed: {
    category() {
      return this.$route.params.category
    }
  }
}
</script>